module.exports = __webpack_public_path__ + "img/icon4.2f79a96f.png";